module.exports = new __parcel__URL__("ugo-martin.84997978.jpeg").toString();